<template>
<div class="wallet">
   <!-- <headerLoginNoMenu></headerLoginNoMenu> -->
    <div class="bg">
        <walletCards></walletCards>
    </div>
    <div class="bg-gray">
      <courseWishlist v-if ="showWishList"></courseWishlist>
    </div>
    <infinite-loading  @infinite="infiniteHandler" spinner="waveDots" ref="infiniteLoader">
        <span slot ='no-results'></span>
        <span slot ='no-more'></span>
    </infinite-loading>
</div>
</template>
<script>
import {INSTANCE_NAME} from '@/components/common/constants.js'
import InfiniteLoading from 'vue-infinite-loading'
import { EventBus } from '@/main.js'
import footerArea from '../common/footerArea.vue'
import walletCards from './walletCards.vue'
import courseWishlist from '@/components/wishList/courseWishList.vue'
export default {
  name: 'wallet',
  components: {
    InfiniteLoading,
    footerArea,
    courseWishlist,
    walletCards
  },
  data () {
    return {
      showWishList: false
    }
  },
  mounted () {
    EventBus.$emit('showNav', false)
  },
  created () {
    if (INSTANCE_NAME === 'MAHADEMY') {
      this.$router.push('/home')
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // infiniteHandler - starts lazy loading
    infiniteHandler ($state) {
      this.globalState = $state
      setTimeout(() => {
        this.showWishList = true
        // this.showLibraryCard = true
        $state.loaded()
      }, 2000)
    },
    // handleScroll - handles scrolling
    handleScroll () {
      if (this.showWishList) {
        setTimeout(() => {
          this.showLibraryCard = true
          if (this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            this.globalState.complete()
          }
        }, 2000)
      }
    }
  }
}
</script>
<style lang="scss">
.wallet{
  .bg{
      background:linear-gradient(to right, #61bfee 0%, #af96fa 100%);
      margin-top:-7px;
    }
  .bg-gray{
      background: linear-gradient(to bottom, #fafafa 0%,#ffffff 100%); 
    }
}
</style>




// WEBPACK FOOTER //
// src/components/wallet/wallet.vue?7963b546